
export const REPORT_BAR_REPORT_REQUEST = "REPORT_BAR_REPORT_REQUEST";
export const REPORT_BAR_REPORT_SUCCESS = "REPORT_BAR_REPORT_SUCCESS";
export const REPORT_BAR_REPORT_FAILURE = "REPORT_BAR_REPORT_FAILURE";

export const REPORT_BAR_MONTH_REPORT_REQUEST = "REPORT_BAR_MONTH_REPORT_REQUEST";
export const REPORT_BAR_MONTH_REPORT_SUCCESS = "REPORT_BAR_MONTH_REPORT_SUCCESS";
export const REPORT_BAR_MONTH_REPORT_FAILURE = "REPORT_BAR_MONTH_REPORT_FAILURE";

export const REPORT_BAR_WEEK_SEARCH_REQUEST = "REPORT_BAR_WEEK_SEARCH_REQUEST";
export const REPORT_BAR_WEEK_SEARCH_SUCCESS = "REPORT_BAR_WEEK_SEARCH_SUCCESS";
export const REPORT_BAR_WEEK_SEARCH_FAILURE = "REPORT_BAR_WEEK_SEARCH_FAILURE";

//Date Search
export const BAR_REPORT_DATE_MONTH_SEARCH_REQUEST = "BAR_REPORT_DATE_MONTH_SEARCH_REQUEST";
export const BAR_REPORT_DATE_MONTH_SEARCH_SUCCESS = "BAR_REPORT_DATE_MONTH_SEARCH_SUCCESS";
export const BAR_REPORT_DATE_MONTH_SEARCH_FAILURE = "BAR_REPORT_DATE_MONTH_SEARCH_FAILURE";

export const BAR_REPORT_DATE_WEEK_SEARCH_REQUEST = "BAR_REPORT_DATE_WEEK_SEARCH_REQUEST";
export const BAR_REPORT_DATE_WEEK_SEARCH_SUCCESS = "BAR_REPORT_DATE_WEEK_SEARCH_SUCCESS";
export const BAR_REPORT_DATE_WEEK_SEARCH_FAILURE = "BAR_REPORT_DATE_WEEK_SEARCH_FAILURE";

export const BAR_REPORT_DATE_SEARCH_REQUEST = "BAR_REPORT_DATE_SEARCH_REQUEST";
export const BAR_REPORT_DATE_SEARCH_SUCCESS = "BAR_REPORT_DATE_SEARCH_SUCCESS";
export const BAR_REPORT_DATE_SEARCH_FAILURE = "BAR_REPORT_DATE_SEARCH_FAILURE";

//search
export const REPORT_BAR_REPORT_SEARCH_REQUEST = "REPORT_BAR_REPORT_SEARCH_REQUEST";
export const REPORT_BAR_REPORT_SEARCH_SUCCESS = "REPORT_BAR_REPORT_SEARCH_SUCCESS";
export const REPORT_BAR_REPORT_SEARCH_FAILURE = "REPORT_BAR_REPORT_SEARCH_FAILURE";